import angular from 'angular';

module.exports = angular.module('common.filters.percentage', [
  require('./trimmed-number'),
  require('common/services/blank')
])
.filter('percentage', function(trimmedNumberFilter, isBlank) {
  return function(num, fractionSize, options) {
    if (isBlank(num))
      return '—';
    let result = trimmedNumberFilter(num * 100, fractionSize) + '%';

    options = options || {};
    if (options.alwaysShowSign && num >= 0)
      result = '+' + result;
    if (options.dashForZero && num === 0)
      result = '—';

    return result;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/percentage.js
 **/